import {
  DETECTOR_RESULTS,
  DOCUMENT_TYPE,
  FILE_TYPE,
  TEXT,
} from './requirementVariables';
import { getDocumentTypeText } from '../utils/documentType';
import { getFileTypeText } from '../utils/fileType';
import { COLOR_CYAN, COLOR_YELLOW } from './colors';
import { getSignalName } from '../utils/signalNames';

const resolveTextValue = (value) => {
  const numPages = Object.keys(value).length;
  const numInstances = Object.values(value).reduce(
    (sum, page) => page.length + sum,
    0,
  );
  return `${numInstances} instance${
    numInstances > 1 ? 's' : ''
  } found across ${numPages}${numPages > 1 ? 's' : ''}`;
};

const defaultResolver = (value) => value;

const requirementConfig = {
  [DOCUMENT_TYPE]: {
    resolveValue: getDocumentTypeText,
  },
  [FILE_TYPE]: {
    resolveValue: getFileTypeText,
  },
  [DETECTOR_RESULTS]: {
    resolveValue: getSignalName,
  },
  [TEXT]: {
    resolveValue: defaultResolver,
    resolveActualValue: resolveTextValue,
    hasSignals: true,
    transformSignal: (value, requirement, config) => ({
      text: value.text,
      color: requirement.passed ? COLOR_CYAN : COLOR_YELLOW,
      instance: {
        boundingBox: value.instance,
        bounding_boxes: [value.instance],
      },
      requirement,
    }),
  },
};

export default requirementConfig;
